<template>
  <section id="wordcloud" class="max-w-[1080px] lg:m-[auto]">
    <div class="bg-white rounded-2xl drop-shadow px-8 py-10 flex flex-col gap-y-6">
      <h3 class="font-markPro font-bold text-xl text-dark">{{ t(`pages.info.integrations_detail.${integrationKey}.wordcloud_title`) }}</h3>
      <div class="flex flex-wrap gap-x-4 gap-y-3 items-baseline">
        <span
          v-for="(tag, i) in tags"
          :key="i"
          :class="CLASSES[i % CLASSES.length]">{{ tag }}</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ integrationKey: string }>()

const { t, tm } = useI18n()

const tags = computed(() => tm(`pages.info.integrations_detail.${props.integrationKey}.wordcloud`) as string[])

const CLASSES = [
  'text-2xl font-bold font-markPro text-gradient-primary',
  'text-base font-semibold text-lighter',
  'text-xl font-bold text-dark font-markPro',
  'text-sm font-semibold text-lighter',
  'text-2xl font-bold text-gradient-primary',
  'text-lg font-bold text-dark',
  'text-base font-semibold text-lighter',
  'text-xl font-bold text-gradient-primary',
  'text-sm font-semibold text-dark',
  'text-2xl font-bold text-dark font-markPro',
  'text-base font-semibold text-lighter',
  'text-lg font-bold text-gradient-primary',
  'text-sm font-semibold text-lighter',
  'text-xl font-bold text-dark',
  'text-base font-semibold text-lighter',
]
</script>
